<template>
  <div>
    <div class="bank-info" >
      <legend>Distributions Bank Info</legend>
      <p class="top">
        Please provide details of a bank account to which distributions from {{ offeringName }} are to be sent. All
        distributions payable to you will be sent to this bank account.
      </p>
      <div class="checkbox checkbox-primary" v-show="isVisible === 'pad'">
        <input type="checkbox" class="styled" name="same_as_pad_bank_information" v-model="sameBank"/>
        <label>Same bank account as Pre-Authorized Debit for subscription fund transfer</label>
      </div>
    </div>
      <div>
        <non-pad-bank :non-pad-visible="sameBank" :bank-data="bankInfo" :old-data="oldData" :errors="errorState" :has-pad="isVisible"></non-pad-bank>
      </div>
  </div>
</template>

<script>
import NonPadBank from "./forms/NonPadBank";
export default {
  name: "DistributionForm",
  components: {
    NonPadBank,
  },
  props: {
    isVisible: '',
    bankInfo: '',
    oldData: '',
    errorState: '',
    offeringName: '',
  },
  data() {
    return {
      sameBank: this.bankInfo.same_as_pad_bank_information,
    }
  },
}
</script>